/* eslint-disable */
import {
  MenuItemsType,
  SwapIcon,
  SwapFillIcon,
  EarnIcon,
  TrophyFillIcon,
  MoreIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { DropdownMenuItems } from '@pancakeswap/uikit/src/components/DropdownMenu/types'
import { DropdownMenuItemType } from '@pancakeswap/uikit/src/components/DropdownMenu/types'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean } & {
  items?: ConfigMenuDropDownItemsType[]
}

const filterItemBySupportChainId = (item, chainId) => {
  return !chainId || !item.supportChainIds ? true : item.supportChainIds?.includes(chainId)
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, chainId) =>
    [
      {
        label: t('Swap'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: '/swap',
        showItemsOnMobile: false,
        items: [],
      },
      {
        label: t('Pools'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: '/liquidity',
        showItemsOnMobile: false,
        items: [],
      },
      {
        label: 'Chart',
        href: 'https://www.dextools.io/app/bnb/pair-explorer/0x9b61a3d2927d01a86ddbb93b0e03b2274628284b',
        icon: EarnIcon,
        type: DropdownMenuItemType.EXTERNAL_LINK,
        items: []
      },
      {
        label: "",
        href: "#",
        icon: MoreIcon,
        items: [
          {
            label: "Marketplace",
            href: "#sec",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "NFTs",
            href: "#sec",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "Bitcoin Cash",
            href: "https://24bitc.com/",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "Document",
            href: "https://bitsmile.gitbook.io/bitcoin-cash",
            type: DropdownMenuItemType.EXTERNAL_LINK
          }
        ]
      }
    ].filter((item) => filterItemBySupportChainId(item, chainId))

export default config